<script>
	import { onMount } from "svelte";
	import { nav } from "./store.js";
	let burned = "0000000000000";
	let goalburned;
	let counting = 999;


	onMount(() => {


		fetch('data.json')
  			.then(response => response.json())
  			.then(data => data["data"])
			.then(data => countingas(data))  
			.catch(()=>{countingas(200000)})

		
		function countingas (data) {
		goalburned = data;
		let inter = ((goalburned - (goalburned % counting) ) / counting) ;
		const wipeout = document.querySelector(".wipeout");
		wipeout.style.visibility = "hidden";
		wipeout.style.transform = "translateX(0%)";
		let timer = 0
		const intervalnum = setInterval(() => {
			burned = burned.split("");
			if (timer < inter) {
				var val = (timer+1) * counting;
				val = val.toString().split("");
				for (let i = 0; i < val.length; i++){
					burned[(burned.length - (val.length - i ))] = val[i];
				}
				burned = burned.join("");
				timer = timer + 1;
			}
			if (timer == inter) {
				var val = goalburned.toString().split("")
				for (let i = 0; i < val.length; i++){
					burned[(burned.length - (val.length - i ))] = val[i];
				}
				burned = burned.join("");
				timer = timer + 1;
			}
			if (timer > inter) {
				clearInterval(intervalnum);
			}

		}, 50);
		
	}
	});

	function wipe(navfunc) {
		const wipeout = document.querySelector(".wipeout");
		wipeout.style.visibility = "visible";
		wipeout.style.transform = "translateX(-102%)";
		setTimeout(navfunc, 800);
	}
</script>

<section>
	<script src=""></script>

	<article class="stat">
		<a href="https://bscscan.com/"> <h1>Total Burned Amount</h1> </a>
		<div>
			<a href="https://bscscan.com/">
				<svg
					width="31"
					height="24"
					viewBox="0 0 31 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M30.0607 13.0607C30.6464 12.4749 30.6464 11.5251 30.0607 10.9393L20.5147 1.3934C19.9289 0.807612 18.9792 0.807612 18.3934 1.3934C17.8076 1.97918 17.8076 2.92893 18.3934 3.51472L26.8787 12L18.3934 20.4853C17.8076 21.0711 17.8076 22.0208 18.3934 22.6066C18.9792 23.1924 19.9289 23.1924 20.5147 22.6066L30.0607 13.0607ZM0 13.5H29V10.5H0V13.5Z"
						fill="#FF7A22"
					/>
				</svg>
				<h2>
					{burned}
				</h2>
			</a>
			<div>
				<hr noshade />
				<p>in</p>
				<hr noshade />
			</div>
			<h2>1,000,000,000,000</h2>
		</div>
	</article>

	<article class="circle">
		<div />

		<svg
			width="520"
			height="460"
			viewBox="0 0 520 460"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="Group 31">
				<circle
					id="Ellipse 5"
					cx="320"
					cy="256"
					r="200"
					fill="#CC5100"
				/>
				<g id="Group 32">
					<mask
						id="mask0_37_6"
						style="mask-type:alpha"
						maskUnits="userSpaceOnUse"
						x="120"
						y="56"
						width="400"
						height="400"
					>
						<circle
							id="Ellipse 6"
							cx="320"
							cy="256"
							r="200"
							fill="#CC5100"
						/>
					</mask>
					<g mask="url(#mask0_37_6)">
						<path
							id="Vector"
							d="M277.511 60.1038L319.5 255.5L492.955 155.567L449 14L277.511 60.1038Z"
							fill="#00C1CC"
							stroke="#00C1CC"
							stroke-width="4"
						/>
					</g>
				</g>
				<g id="Group 33">
					<path
						id="p20"
						d="M366.797 155H351.891V152.922L359.766 144.172C360.932 142.849 361.734 141.776 362.172 140.953C362.62 140.12 362.844 139.26 362.844 138.375C362.844 137.188 362.484 136.214 361.766 135.453C361.047 134.693 360.089 134.312 358.891 134.312C357.453 134.312 356.333 134.724 355.531 135.547C354.74 136.359 354.344 137.495 354.344 138.953H351.453C351.453 136.859 352.125 135.167 353.469 133.875C354.823 132.583 356.63 131.938 358.891 131.938C361.005 131.938 362.677 132.495 363.906 133.609C365.135 134.714 365.75 136.188 365.75 138.031C365.75 140.271 364.323 142.938 361.469 146.031L355.375 152.641H366.797V155ZM384.125 145.297C384.125 148.682 383.547 151.198 382.391 152.844C381.234 154.49 379.427 155.312 376.969 155.312C374.542 155.312 372.745 154.51 371.578 152.906C370.411 151.292 369.807 148.885 369.766 145.688V141.828C369.766 138.484 370.344 136 371.5 134.375C372.656 132.75 374.469 131.938 376.938 131.938C379.385 131.938 381.188 132.724 382.344 134.297C383.5 135.859 384.094 138.276 384.125 141.547V145.297ZM381.234 141.344C381.234 138.896 380.891 137.115 380.203 136C379.516 134.875 378.427 134.312 376.938 134.312C375.458 134.312 374.38 134.87 373.703 135.984C373.026 137.099 372.677 138.812 372.656 141.125V145.75C372.656 148.208 373.01 150.026 373.719 151.203C374.438 152.37 375.521 152.953 376.969 152.953C378.396 152.953 379.453 152.401 380.141 151.297C380.839 150.193 381.203 148.453 381.234 146.078V141.344ZM387.578 136.625C387.578 135.26 388.01 134.135 388.875 133.25C389.75 132.365 390.87 131.922 392.234 131.922C393.62 131.922 394.74 132.37 395.594 133.266C396.458 134.151 396.891 135.302 396.891 136.719V137.828C396.891 139.203 396.453 140.328 395.578 141.203C394.714 142.068 393.609 142.5 392.266 142.5C390.911 142.5 389.792 142.068 388.906 141.203C388.021 140.328 387.578 139.167 387.578 137.719V136.625ZM389.734 137.828C389.734 138.641 389.964 139.312 390.422 139.844C390.88 140.365 391.495 140.625 392.266 140.625C393.005 140.625 393.599 140.37 394.047 139.859C394.505 139.349 394.734 138.651 394.734 137.766V136.625C394.734 135.812 394.51 135.141 394.062 134.609C393.615 134.078 393.005 133.812 392.234 133.812C391.464 133.812 390.854 134.078 390.406 134.609C389.958 135.141 389.734 135.833 389.734 136.688V137.828ZM398.656 149.422C398.656 148.057 399.089 146.938 399.953 146.062C400.828 145.177 401.948 144.734 403.312 144.734C404.677 144.734 405.797 145.172 406.672 146.047C407.547 146.922 407.984 148.083 407.984 149.531V150.641C407.984 152.005 407.547 153.13 406.672 154.016C405.807 154.891 404.698 155.328 403.344 155.328C401.99 155.328 400.87 154.896 399.984 154.031C399.099 153.156 398.656 151.995 398.656 150.547V149.422ZM400.812 150.641C400.812 151.464 401.042 152.141 401.5 152.672C401.958 153.193 402.573 153.453 403.344 153.453C404.094 153.453 404.693 153.198 405.141 152.688C405.589 152.167 405.812 151.464 405.812 150.578V149.422C405.812 148.599 405.583 147.927 405.125 147.406C404.677 146.885 404.073 146.625 403.312 146.625C402.573 146.625 401.969 146.885 401.5 147.406C401.042 147.917 400.812 148.609 400.812 149.484V150.641ZM392.922 153.281L391.281 152.25L402.391 134.469L404.031 135.5L392.922 153.281Z"
						fill="white"
					/>
					<path
						id="row20"
						d="M374 109.5L348 3H0"
						stroke="white"
						stroke-width="5"
					/>
				</g>
				<g id="Group 34">
					<path
						id="p80"
						d="M268.688 332.188C268.688 333.323 268.385 334.333 267.781 335.219C267.188 336.104 266.38 336.797 265.359 337.297C266.547 337.807 267.484 338.552 268.172 339.531C268.87 340.51 269.219 341.62 269.219 342.859C269.219 344.828 268.552 346.396 267.219 347.562C265.896 348.729 264.151 349.312 261.984 349.312C259.797 349.312 258.042 348.729 256.719 347.562C255.406 346.385 254.75 344.818 254.75 342.859C254.75 341.63 255.083 340.521 255.75 339.531C256.427 338.542 257.359 337.792 258.547 337.281C257.536 336.781 256.74 336.089 256.156 335.203C255.573 334.318 255.281 333.312 255.281 332.188C255.281 330.271 255.896 328.75 257.125 327.625C258.354 326.5 259.974 325.938 261.984 325.938C263.984 325.938 265.599 326.5 266.828 327.625C268.068 328.75 268.688 330.271 268.688 332.188ZM266.328 342.797C266.328 341.526 265.922 340.49 265.109 339.688C264.307 338.885 263.255 338.484 261.953 338.484C260.651 338.484 259.604 338.88 258.812 339.672C258.031 340.464 257.641 341.505 257.641 342.797C257.641 344.089 258.021 345.104 258.781 345.844C259.552 346.583 260.62 346.953 261.984 346.953C263.339 346.953 264.401 346.583 265.172 345.844C265.943 345.094 266.328 344.078 266.328 342.797ZM261.984 328.312C260.849 328.312 259.927 328.667 259.219 329.375C258.521 330.073 258.172 331.026 258.172 332.234C258.172 333.391 258.516 334.328 259.203 335.047C259.901 335.755 260.828 336.109 261.984 336.109C263.141 336.109 264.062 335.755 264.75 335.047C265.448 334.328 265.797 333.391 265.797 332.234C265.797 331.078 265.438 330.135 264.719 329.406C264 328.677 263.089 328.312 261.984 328.312ZM287.125 339.297C287.125 342.682 286.547 345.198 285.391 346.844C284.234 348.49 282.427 349.312 279.969 349.312C277.542 349.312 275.745 348.51 274.578 346.906C273.411 345.292 272.807 342.885 272.766 339.688V335.828C272.766 332.484 273.344 330 274.5 328.375C275.656 326.75 277.469 325.938 279.938 325.938C282.385 325.938 284.188 326.724 285.344 328.297C286.5 329.859 287.094 332.276 287.125 335.547V339.297ZM284.234 335.344C284.234 332.896 283.891 331.115 283.203 330C282.516 328.875 281.427 328.312 279.938 328.312C278.458 328.312 277.38 328.87 276.703 329.984C276.026 331.099 275.677 332.812 275.656 335.125V339.75C275.656 342.208 276.01 344.026 276.719 345.203C277.438 346.37 278.521 346.953 279.969 346.953C281.396 346.953 282.453 346.401 283.141 345.297C283.839 344.193 284.203 342.453 284.234 340.078V335.344ZM290.578 330.625C290.578 329.26 291.01 328.135 291.875 327.25C292.75 326.365 293.87 325.922 295.234 325.922C296.62 325.922 297.74 326.37 298.594 327.266C299.458 328.151 299.891 329.302 299.891 330.719V331.828C299.891 333.203 299.453 334.328 298.578 335.203C297.714 336.068 296.609 336.5 295.266 336.5C293.911 336.5 292.792 336.068 291.906 335.203C291.021 334.328 290.578 333.167 290.578 331.719V330.625ZM292.734 331.828C292.734 332.641 292.964 333.312 293.422 333.844C293.88 334.365 294.495 334.625 295.266 334.625C296.005 334.625 296.599 334.37 297.047 333.859C297.505 333.349 297.734 332.651 297.734 331.766V330.625C297.734 329.812 297.51 329.141 297.062 328.609C296.615 328.078 296.005 327.812 295.234 327.812C294.464 327.812 293.854 328.078 293.406 328.609C292.958 329.141 292.734 329.833 292.734 330.688V331.828ZM301.656 343.422C301.656 342.057 302.089 340.938 302.953 340.062C303.828 339.177 304.948 338.734 306.312 338.734C307.677 338.734 308.797 339.172 309.672 340.047C310.547 340.922 310.984 342.083 310.984 343.531V344.641C310.984 346.005 310.547 347.13 309.672 348.016C308.807 348.891 307.698 349.328 306.344 349.328C304.99 349.328 303.87 348.896 302.984 348.031C302.099 347.156 301.656 345.995 301.656 344.547V343.422ZM303.812 344.641C303.812 345.464 304.042 346.141 304.5 346.672C304.958 347.193 305.573 347.453 306.344 347.453C307.094 347.453 307.693 347.198 308.141 346.688C308.589 346.167 308.812 345.464 308.812 344.578V343.422C308.812 342.599 308.583 341.927 308.125 341.406C307.677 340.885 307.073 340.625 306.312 340.625C305.573 340.625 304.969 340.885 304.5 341.406C304.042 341.917 303.812 342.609 303.812 343.484V344.641ZM295.922 347.281L294.281 346.25L305.391 328.469L307.031 329.5L295.922 347.281Z"
						fill="white"
					/>
					<path
						id="row80"
						d="M273.5 303L247.5 220H29"
						stroke="white"
						stroke-width="5"
					/>
				</g>
			</g>
		</svg>

		<p class="r80">For sale</p>
		<p class="r20">Airdrop - Bounty and locked <br />liquidity (for dex)</p>
	</article>

	<img class="back" src="./big.png" alt="" />
	<div
		on:click={() => {
			wipe(() => nav.set("about"));
		}}
		class="navbutton2"
	>
		<svg
			width="31"
			height="24"
			viewBox="0 0 31 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M30.0607 13.0607C30.6464 12.4749 30.6464 11.5251 30.0607 10.9393L20.5147 1.3934C19.9289 0.807612 18.9792 0.807612 18.3934 1.3934C17.8076 1.97918 17.8076 2.92893 18.3934 3.51472L26.8787 12L18.3934 20.4853C17.8076 21.0711 17.8076 22.0208 18.3934 22.6066C18.9792 23.1924 19.9289 23.1924 20.5147 22.6066L30.0607 13.0607ZM0 13.5H29V10.5H0V13.5Z"
				fill="#FF7A22"
			/>
		</svg>
	</div>
</section>

<style>
	@keyframes back-move {
		0% {
			transform: translate(-50%, calc(-40% - 50px));
		}
		50% {
			transform: translate(-50%, calc(-40% + 40px));
		}
		100% {
			transform: translate(-50%, calc(-40% - 50px));
		}
	}
	section {
		width: 100vw;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: space-between;

		overflow: hidden;
	}

	article.stat {
		border-radius: 10px;
		background-color: rgba(0, 0, 0, 0.25);
		width: 40vw;
		margin-left: 10%;
		margin-top: 1rem;
		text-align: center;

		transition: all 0.3s ease;
	}
	article.stat > div {
		margin-top: 1rem;
		padding: 1rem;
	}
	article.stat h1 {
		font-size: 1rem;
		margin-top: 2rem;
		text-transform: uppercase;
		transition: all 0.3s ease;
	}
	article.stat div h2 {
		font-size: 1.8rem;
		text-transform: uppercase;
		transition: all 0.3s ease;
	}
	article.stat div > div {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 1rem;
		gap: 1rem;
	}
	article.stat div hr {
		width: 100%;
	}
	article.stat a {
		color: white;
		text-decoration: none;
	}
	article.stat div a {
		min-width: 14rem;
		font-size: 1.8rem;

		display: flex;
		align-items: center;
		justify-content: center;

		text-decoration: none;
		color: white;

		padding: 1rem 2rem;
		padding-right: 3rem;
		border-radius: 50vh;
		transition: all 0.3s ease;
	}
	article.stat  a h2 {
		margin: 0;
	}
	article.stat  a svg {
		height: 1rem;
		margin-right: 1rem;
		width: auto;
	}
	article.stat a:hover {
		text-decoration: none;
		color: #ff7a22;
		background: white;
	}

	article.circle {
		padding: 3vw;
		margin-right: 10vw;
		position: relative;

		/* border-radius: 50vh; */
		border-radius: 10px;
		background-color: rgba(0, 0, 0, 0.25);
		transition: all 0.3s ease;
		cursor: pointer;
	}
	article.circle > div {
		position: absolute;
		left: 0;
		top: 0;
		z-index: -10;
		width: 200vw;
		height: 200vh;
		transform: translate(-50%, -50%);
		background-color: rgba(0, 0, 0, 0.25);
		opacity: 0;
		transition: all 0.3s ease;
	}
	article.circle svg {
		margin-left: 2rem;
		height: 22vw;
		width: auto;
		z-index: 2;
	}
	article.circle .r20 {
		position: absolute;
		top: 4.5vw;
		left: 2vw;
	}
	article.circle .r80 {
		position: absolute;
		top: 15vw;
		left: 5vw;
	}
	#p20, #p80, #row20, #row80, .r80, .r20 {
		opacity: 0;
		transition: all 0.3s ease;
		z-index: 2;
	}

	article.circle:hover {
		padding: 4vw;
		margin-right: 9vw;
	}
	article.circle:hover > div {
		opacity: 1;
	}
	article.circle:hover #p20,
	article.circle:hover #p80,
	article.circle:hover #row20,
	article.circle:hover #row80,
	article.circle:hover .r20,
	article.circle:hover .r80 {
		opacity: 1;
	}

	.navbutton2 {
		position: absolute;
		width: 3rem;
		height: 3rem;
		top: 50%;
		right: 100%;
		transform: translate(80%, -50%);

		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding-left: 0.9rem;
		background-color: rgba(0, 0, 0, 0.5);
		border-radius: 50vh;
		transition: all 0.3s ease;
		cursor: pointer;
	}
	.navbutton2 svg {
		width: 1.5rem;
		height: 2rem;
		transform: rotate(180deg);
	}
	.navbutton2:hover {
		transform: translate(90%, -50%) scale(140%);
		background-color: rgba(0, 0, 0, 0.75);
	}

	img.back {
		width: 80vw;
		height: 60vh;
		z-index: -20;
		position: absolute;
		top: 50%;
		left: 50%;
		opacity: 0.1;
		transform: translate(-50%, -40%);

		animation-name: back-move;
		animation-duration: 30s;
		animation-iteration-count: infinite;
	}

	@media only screen and (max-width: 1280px) {
		article.circle svg {
			/* changed */
			margin-left: 8vh;
			/* changed */
			height: 24vh;
		
		}
		article.circle .r20 {
	
			/* changed  */
			width: 35%;

			/* changed */
			top: 6vh;
			/* changed */
			font-size: 0.8rem;
			
		}
		article.circle .r80 {

			/* changed */
			font-size: 0.8rem;
			/* changed */
			top: 17vh;
			/* changed */

			/* changed  */
			width: 35%;
			
			/* changed  */
			left: 5vh;

		}
	}

	@media only screen and (max-width: 1000px) {
		section {

			/* changed */
			flex-direction: column;
			align-items: center;
			justify-content: space-evenly;
		}

		article.stat {
			border-radius: 10px;
			background-color: rgba(0, 0, 0, 0.25);
			/* changed */
			width: 80vw;
			/* changed */
			margin-left: 0;
			/* changed */
			margin-top: 3rem;
			text-align: center;

			transition: all 0.3s ease;
		}
		/* changed */
		article.stat > div {
			margin-top: 0.8rem;
			padding: 0.8rem;
		}
		article.stat h1 {
			/* changed */
			font-size: 0.8rem;
			/* changed */
			margin-top: 1rem;
			text-transform: uppercase;
			transition: all 0.3s ease;
		}
		article.stat div h2 {
			/* changed */
			font-size: 1.6rem;
			margin: 0.6rem 0;
			text-transform: uppercase;
			transition: all 0.3s ease;
		}
		article.stat div > div {
			display: flex;
			align-items: center;
			justify-content: center;
			/* changed */
			margin-top: 0rem;
			gap: 1rem;
		}
		article.stat div hr {
			width: 100%;
		}
		article.stat div a {
			/* changed */
			min-width: 12rem;
			/* changed */
			font-size: 1.6rem;

			display: flex;
			align-items: center;
			justify-content: center;

			text-decoration: none;
			color: white;

			/* changed */
			padding: 0.6rem 1.2rem;
			padding-right: 3rem;
			border-radius: 50vh;
			transition: all 0.3s ease;
		}
		article.stat div a svg {
			/* changed */
			height: 0.8rem;
			margin-right: 1rem;
			width: auto;
		}
		article.stat div a:hover {
			text-decoration: none;
			color: #ff7a22;
			background: white;
		}

		article.circle {
			/* changed */
			padding: 4vh;
			/* changed */
			margin-right: 0;
			position: relative;

			/* border-radius: 50vh; */
			border-radius: 10px;
			background-color: rgba(0, 0, 0, 0.25);
			transition: all 0.3s ease;
			cursor: pointer;
		}
		article.circle > div {
			position: absolute;
			left: 0;
			top: 0;
			z-index: -10;
			width: 200vw;
			height: 200vh;
			transform: translate(-50%, -50%);
			background-color: rgba(0, 0, 0, 0.25);
			opacity: 0;
			transition: all 0.3s ease;
		}
		article.circle svg {
			/* changed */
			margin-left: 5vh;
			/* changed */
			height: 25vh;
			width: auto;
			z-index: 2;
		}
		article.circle .r20 {
			position: absolute;
			/* changed */
			font-size: 0.6rem;
			top: 5vh;
			/* changed */
			width: auto;

			left: 2vw;
		
		}
		article.circle .r80 {
			position: absolute;
			/* changed */
			font-size: 0.6rem;
			/* changed */
			width: auto;

			top: 16vh;
			/* changed */
			left: 6vw;
			transform: translateY(100%);
		}
		#p20, #p80, /*#row20, #row80,*/ .r80, .r20 {
			opacity: 0;
			transition: all 0.3s ease;
			z-index: 2;
		}

		article.circle:hover {
			padding: 4vw;
			/* changed */
			margin-right: 0;
		}

	}

	/* mobile */
	@media only screen and (max-width: 800px) {
		section {
			width: 100vw;
			height: 100vh;
			display: flex;
			/* changed */
			flex-direction: column;
			align-items: center;
			justify-content: space-evenly;

			overflow: hidden;
		}

		article.stat {
			border-radius: 10px;
			background-color: rgba(0, 0, 0, 0.25);
			/* changed */
			width: 80vw;
			/* changed */
			margin-left: 0;
			/* changed */
			margin-top: 3rem;
			text-align: center;

			transition: all 0.3s ease;
		}
		/* changed */
		article.stat > div {
			margin-top: 0.8rem;
			padding: 0.8rem;
		}
		article.stat h1 {
			/* changed */
			font-size: 0.8rem;
			/* changed */
			margin-top: 1rem;
			text-transform: uppercase;
			transition: all 0.3s ease;
		}
		article.stat div h2 {
			/* changed */
			font-size: 1.6rem;
			margin: 0.6rem 0;
			text-transform: uppercase;
			transition: all 0.3s ease;
		}
		article.stat div > div {
			display: flex;
			align-items: center;
			justify-content: center;
			/* changed */
			margin-top: 0rem;
			gap: 1rem;
		}
		article.stat div hr {
			width: 100%;
		}
		article.stat div a {
			/* changed */
			min-width: 12rem;
			/* changed */
			font-size: 1.6rem;

			display: flex;
			align-items: center;
			justify-content: center;

			text-decoration: none;
			color: white;

			/* changed */
			padding: 0.6rem 1.2rem;
			padding-right: 3rem;
			border-radius: 50vh;
			transition: all 0.3s ease;
		}
		article.stat div a svg {
			/* changed */
			height: 0.8rem;
			margin-right: 1rem;
			width: auto;
		}
		article.stat div a:hover {
			text-decoration: none;
			color: #ff7a22;
			background: white;
		}

		article.circle {
			/* changed */
			padding: 4vh;
			/* changed */
			margin-right: 0;
			position: relative;

			/* border-radius: 50vh; */
			border-radius: 10px;
			background-color: rgba(0, 0, 0, 0.25);
			transition: all 0.3s ease;
			cursor: pointer;
		}
		article.circle > div {
			position: absolute;
			left: 0;
			top: 0;
			z-index: -10;
			width: 200vw;
			height: 200vh;
			transform: translate(-50%, -50%);
			background-color: rgba(0, 0, 0, 0.25);
			opacity: 0;
			transition: all 0.3s ease;
		}
		article.circle svg {
			/* changed */
			margin-left: 5vh;
			/* changed */
			height: 25vh;
			width: auto;
			z-index: 2;
		}
		article.circle .r20 {
			position: absolute;
			/* changed */
			font-size: 0.6rem;
			top: 0px;
			/* changed */
			width: auto;

			left: 2vw;
			transform: translateY(100%);
		}
		article.circle .r80 {
			position: absolute;
			/* changed */
			font-size: 0.6rem;
			/* changed */
			width: auto;

			top: 13vh;
			/* changed */
			left: 6vw;
			transform: translateY(100%);
		}
		#p20, #p80, /*#row20, #row80,*/ .r80, .r20 {
			opacity: 0;
			transition: all 0.3s ease;
			z-index: 2;
		}

		article.circle:hover {
			padding: 4vw;
			/* changed */
			margin-right: 0;
		}
		article.circle:hover > div {
			opacity: 1;
		}
		article.circle:hover #p20,
		article.circle:hover #p80,
		article.circle:hover #row20,
		article.circle:hover #row80,
		article.circle:hover .r20,
		article.circle:hover .r80 {
			opacity: 1;
		}

		.navbutton2 {
			position: absolute;
			width: 3rem;
			height: 3rem;
			top: 50%;
			right: 100%;
			transform: translate(80%, -50%);

			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding-left: 0.9rem;
			background-color: rgba(0, 0, 0, 0.5);
			border-radius: 50vh;
			transition: all 0.3s ease;
			cursor: pointer;
		}
		.navbutton2 svg {
			width: 1.5rem;
			height: 2rem;
			transform: rotate(180deg);
		}
		.navbutton2:hover {
			transform: translate(90%, -50%) scale(140%);
			background-color: rgba(0, 0, 0, 0.75);
		}

		img.back {
			width: 80vw;
			/* changed */
			height: 30vh;
			z-index: -20;
			position: absolute;
			top: 50%;
			left: 50%;
			opacity: 0.1;
			transform: translate(-50%, -40%);

			animation-name: back-move;
			animation-duration: 30s;
			animation-iteration-count: infinite;
		}
	}
</style>
